import { jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM3 8c0 2.755 2.245 5 5 5s5-2.245 5-5-2.245-5-5-5-5 2.245-5 5Zm7.03 2.32.005-.005-.005.005Zm0 0-.52-.835c-.27.23-.66.365-1.115.365-.58 0-1.105-.245-1.4-.76H8.21l.365-.795h-1.82c-.015-.15-.015-.21-.015-.26 0-.095 0-.16.015-.28h2.04l.37-.795h-2.19c.305-.555.85-.81 1.425-.81.405 0 .76.08 1.02.26l.43-.89c-.38-.245-.835-.39-1.45-.39-1.16 0-2.24.675-2.645 1.825H4.97v.795h.615c-.01.135-.01.205-.01.27 0 .075 0 .12.01.27H4.97v.795h.785c.405 1.14 1.455 1.79 2.645 1.79.672 0 1.24-.243 1.63-.556Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  e as Euro
};
